// Copyright (c) StrangeBee 2024

import { Route as LicenseRoute } from './License/Details/';
import { Route as PlatformStatusRoute } from './PlatformStatus/Details/';
import { Route as BrandingRoute } from './Branding/Details/';
import { Route as CortexRoute } from './Cortex/Details/';
import { Route as MispRoute } from './Misp/Details/';
import { Route as AuthRoute } from './Authentication/Details/';
import { Route as MailerRoute } from './Mailer/Details/';
import { Route as GlobalEndpoints } from './GlobalEndpoints/List';
import { Route as LdapServers } from './LdapServers/List';

export default [
    LicenseRoute,
    PlatformStatusRoute,
    BrandingRoute,
    CortexRoute,
    MispRoute,
    AuthRoute,
    MailerRoute,
    GlobalEndpoints,
    LdapServers,
];
